<template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="users"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-page="changePage"
			@on-search-event="onSearch"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.email }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.codeUser }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.company.data.nombreComercial }}
				</td>
				<td>
					<v-tooltip top>
						<v-btn icon slot="activator">
							<v-switch
								class="ml-3 mt-0"
								hide-details
								v-model="props.row.status"
								@change="changeState(props.row)"
							>
							</v-switch>
						</v-btn>
						<span>Cambiar Estado</span>
					</v-tooltip>
					<app-tooltip-button
						color="red"
						icon="devices"
						text="Dispositivos"
						@click-icon="showDevices(props.row)"
					/>
					<app-tooltip-button
						color="primary"
						icon="description"
						text="Asignar Aplicaciones"
						@click-icon="openApps(props.row)"
					/>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar"
						@click-icon="openEdit(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="vpn_key"
						text="Editar contraseña"
						@click-icon="change(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<devices
			:value="isOpen"
			:devices="devices"
			:lastPage="lastPageDevices"
			:currentPage="currentPageDevices"
			@toggle-devices="toggleDevices"
			@refresh-data="refreshData"
			@change-device-page="changeDevicePage"/>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import devices from '@/components/devices/devices';

function change({ codeUser }) {
	const codeProject = this.codeProject;
	this.goTo('page-users-change-password', { params: { id: codeUser, codeProject } });
}

function changePage(page) {
	this.$emit('change-page', page);
}

function changeState(user) {
	const model = { user, codeProject: this.codeProject, codeCompany: this.companyCode };
	this.$emit('change-state', model);
}

function refreshData() {
	const user = this.userSelected;
	const model = { user, codeProject: this.codeProject, codeCompany: this.companyCode };
	this.$emit('refresh-data', model);
}

function openApps({ codeUser }) {
	const codeProject = this.codeProject;
	const idCompany = this.companyCode;
	this.goTo('page-app-user', { params: { codeProject, idCompany, codeUser } });
}

function openEdit({ id }) {
	const codeProject = this.codeProject;
	const companyCode = this.companyCode;
	this.goTo('page-user-edit', { params: { codeProject, companyCode, id } });
}

function toggleDevices() {
	this.isOpen = !this.isOpen;
}

async function showDevices(row) {
	const userId = row.id;
	const companyId = row.company.data.id;
	const projectId = row.company.data.projectId;
	this.params.typeUser = row.typeUser;
	try {
		const query = {
			params: this.params,
		};
		const url = `user/${userId}/${projectId}/${companyId}/devices`;
		const { data: records, headers } = await this.$http.get(url, query);
		this.lastPageDevices = Number(headers['x-last-page']);
		this.devices = records.data.map((d) => {
			const newDevice = { ...d };
			newDevice.isSelected = false;
			return newDevice;
		}) || [];
		this.isOpen = true;
		this.userSelected = { ...row };
	} catch (error) {
		this.showError();
		this.isOpen = false;
	}
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function changeDevicePage(page) {
	this.params.page = page;
	this.currentPageDevices = page;
	this.showDevices(this.userSelected);
}

function data() {
	return {
		isOpen: false,
		devices: [],
		lastPageDevices: 0,
		userSelected: {},
		currentPageDevices: 1,
		params: {
			page: 1,
			perPage: 20,
			search: null,
			typeUser: null,
		},
	};
}

export default {
	name: 'users-list',
	components: {
		appTooltipButton,
		devices,
	},
	data,
	methods: {
		changePage,
		changeState,
		changeDevicePage,
		openApps,
		openEdit,
		onSearch,
		change,
		toggleDevices,
		showDevices,
		refreshData,
	},
	props: {
		codeProject: {
			type: String,
		},
		columns: {
			type: Array,
			required: true,
		},
		companyCode: {
			type: String,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/users/users-list.vue